import './currency-new-modal.tag'
riot.tag2('currencies', '  <catalog object="Currency" cols="{cols}" add="{permission(add, &quot;currencies&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;currencies&quot;, &quot;0001&quot;)}" dblclick="{permission(currencyEdit, &quot;currencies&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="title">{row.title}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="dateReplace">{row.dateReplace}</datatable-cell>\n      <datatable-cell name="rate">{row.rate}</datatable-cell>\n      <datatable-cell name="rateDisplay">{row.rateDisplay}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Currency';

self.cols = [{ name: 'title', value: 'Наименование' }, { name: 'name', value: 'Код' }, { name: 'rateDate', value: 'Дата' }, { name: 'rate', value: 'Курс' }, { name: 'rateDisplay', value: 'Текст' }];

self.add = function () {
    modals.create('currency-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var params = _this.item;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'Currency',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        popups.create({ title: 'Успех!', text: 'Валюта добавлена!', style: 'popup-success' });
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        }
    });
};

self.currencyEdit = function (e) {
    modals.create('currency-new-modal', {
        item: e.item.row,
        type: 'modal-primary',
        title: 'Редактор валюты',
        submit: function submit() {
            var _this = this;
            var params = _this.item;

            API.request({
                object: 'Currency',
                method: 'Save',
                data: params,
                success: function success(response) {
                    popups.create({ title: 'Успех!', text: 'Валюта изменена!', style: 'popup-success' });
                    _this.modalHide();
                    self.tags.catalog.reload();
                }
            });
        }
    });
};
});


// WEBPACK FOOTER //
// ./pages/settings/currencies/currencies.tag